import { LockIcon, NotAllowedIcon, RepeatClockIcon, UnlockIcon, WarningIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { useToast } from '@chakra-ui/react';
import axios from 'axios';
import { createContext, useContext, useEffect, useState } from "react"
import { io } from "socket.io-client";
import jwt_decode from "jwt-decode";
import configData from "../../clientNustatymai";
const SERVER_IP = configData.SERVER_IP   // Serverio IP (kur stovi raspberry)
const loadDataFromEmaitinimas = configData.loadDataFromEmaitinimas;
const isSeveralRaspberryIps = configData.isSeveralRaspberryIps;
const socket = io(`http://${SERVER_IP}:3005`);

// client-side




const DoorContext = createContext();

const DoorContextProvider = ({ children }) => {
    const toast = useToast()


    const [data, setData] = useState([]);
    const [log, setLog] = useState([]);
    const [pickedUserLog, setPickedUserLog] = useState([]);
    const [loading, setLoading] = useState(true);
    const [update, setUpdate] = useState('');
    const [user, setUser] = useState(null);
    const [allLog, setAllLog] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [allCardGroups, setAllCardGroups] = useState([]);
    const [allDoors, setAllDoors] = useState([]);
    const [doorInfos, setDoorInfos] = useState([]);
    const [systemDoors, setSystemDoors] = useState([]);
    const [logAllIps, setLogAllIps] = useState([]);

    const client = axios.create({
        baseURL: `http://${SERVER_IP}:3000`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorization': user ? 'Bearer ' + user.accessToken : ''
        }
    });

    const api_key = { "api_key": '7HQJM49R8JAPR' };

    const persistLogin = async () => {
        console.log('persistLogin')
        if(localStorage.getItem('refreshToken')){
            const data = await refreshToken();
            setUser(data);
        }
    }

    useEffect(() => {
        socket.on("connect", () => {
            console.log('connected', socket.id); //
            toast({
                title: 'Prisijungta prie serverio!',
                position: 'bottom',
                status: 'success',
                isClosable: true,
                duration: 1500
            })
        });

        socket.io.on("reconnect_attempt", () => {
            if(!toast.isActive('reconnect_attempt')){
                toast({
                    id: 'reconnect_attempt',
                    title: 'Signalas su serveriu dingo, bandoma vėl!',
                    position: 'bottom',
                    status: 'warning',
                    isClosable: true,
                    duration: 5000
                })
            }
        });

        socket.on("update", (serverMessage) => {
            setUpdate(serverMessage);
        });

        if(JSON.parse(localStorage.getItem('persistLogin'))){
            persistLogin();
        }

       



        return () => {
            socket.off('connect');
            socket.off('update');
        }
    }, [])


    useEffect(() => {

        if(user){
            if(!localStorage.getItem('refeshToken')){
                localStorage.setItem('refreshToken', user.refreshToken)
            }
       
        client.get('/doors_status').then((response) => {
            setLoading(false);
            setData(response.data);
        });

        client.get(`/access_log`).then((response) => {
            setLoading(false);
            setLog(response.data)

        }); 
    }

    }, [update, user, allEmployees])


    const refreshToken = async () => {
        try {
            const res = await client.post("api/refresh", {
                token: localStorage.getItem('refreshToken')
            });
            setUser(
                {
                    ...user,
                    accessToken: res.data.accessToken,
                    refreshToken: res.data.refreshToken,
                }
                )
                
                    localStorage.setItem('refreshToken', res.data.refreshToken)
                
            return res.data
        } catch (err) {
            if(err.response !== undefined && err.response.status === 403){
                setUser(null);
                toast({
                    title: 'Token galiojimas baigėsi, prisijunkite iš naujo',
                    position: 'bottom',
                    status: 'warning',
                    isClosable: true,
                    duration: 5000
                })
            }else{
                console.log(err);
            }
        }
    }

    const axiosJWT = axios.create({
        baseURL: `http://${SERVER_IP}:3000`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorization': user ? 'Bearer ' + user.accessToken : ''
        }
    });

    axiosJWT.interceptors.request.use( async (config) => {
        const decodedToken = jwt_decode(user.accessToken);
        const hourInMilliseconds = 60 * 60 * 1000;
        const oneHourAfter = (decodedToken.iat * 1000) + hourInMilliseconds;
        if (Date.now() > oneHourAfter){  // refresh token every hour
            console.log('new token')
          const data = await refreshToken();
          config.headers['authorization'] = "Bearer " + data.accessToken;
        }
        return config;
    }, (error) => {
        
        return Promise.reject(console.log('error'))
    })


    const logOutUser = async () => {
        try {
            const res = await client.post("/api/logout", {headers: {authorization: ''}})
            if (res) {
                setUser(null);
                localStorage.removeItem('refreshToken')
                toast({
                    title: res.data,
                    position: 'bottom',
                    status: 'success',
                    isClosable: true,
                    duration: 4000
                })
            }
        } catch (err) {
            console.log(err)
        }
    }

    // const openDoor = (doorID) => {
       

    //     axiosJWT.post(`/open/${doorID}`, api_key).then((response) => {
    //         toast({
    //             title: response.data.message,
    //             position: 'bottom',
    //             status: response.data.status,
    //             isClosable: true,
    //             duration: 4000
    //         })

    //     });
    // }
// const openDoor = async (doorID) => {
//     const doorIp = await getDoorIp(doorID);

//     // jei IP yra pagrindinio serverio – naudojam esamą axiosJWT
//     if (doorIp === SERVER_IP) {
//         axiosJWT.post(`/open/${doorID}`, api_key).then((response) => {
//             toast({
//                 title: response.data.message,
//                 position: 'bottom',
//                 status: response.data.status,
//                 isClosable: true,
//                 duration: 4000
//             });
//         });
//     } else {
//         // kitaip – kreipiamės į kitą Raspberry
//         const axiosJWT_ip = createAxiosForDoorIp(doorIp);

//         axiosJWT_ip.post(`/open/${doorID}`, api_key).then((response) => {
//             toast({
//                 title: response.data.message,
//                 position: 'bottom',
//                 status: response.data.status,
//                 isClosable: true,
//                 duration: 4000
//             });
//         }).catch((err) => {
//             console.error(err);
//             toast({
//                 title: `Nepavyko atrakinti durų per IP ${doorIp}`,
//                 position: 'bottom',
//                 status: 'error',
//                 isClosable: true,
//                 duration: 4000
//             });
//         });
//     }
// };
const sendDoorRequest = async (doorID, endpoint) => {
    const doorIp = await getDoorIp(doorID);
    const axiosClient = (doorIp === SERVER_IP) ? axiosJWT : createAxiosForDoorIp(doorIp);

    try {
        const response = await axiosClient.post(`/${endpoint}/${doorID}`, api_key);

        toast({
            title: response.data.message,
            position: 'bottom',
            status: response.data.status,
            isClosable: true,
            duration: 4000
        });

        return response;
    } catch (err) {
        console.error(err);

        toast({
            title: `Nepavyko atlikti veiksmo (${endpoint}) per IP ${doorIp}, naudotojas neturi prieigos arba įrenginys nepasiekiamas.`,
            position: 'bottom',
            status: 'error',
            isClosable: true,
            duration: 4000
        });
    }
};

const openDoor = (doorID) => sendDoorRequest(doorID, 'open');
const openLongDoor = (doorID) => sendDoorRequest(doorID, 'openlong');
const closeDoor = (doorID) => sendDoorRequest(doorID, 'close');

//Kadangi openall ir closeall neklausinėja doorID, galim pridėt atskirą generalizuotą funkciją:
const sendGlobalDoorRequest = async (endpoint) => {
    try {
        const response = await axiosJWT.post(`/${endpoint}/`, api_key);

        toast({
            title: response.data.message,
            position: 'bottom',
            status: response.data.status,
            isClosable: true,
            duration: 4000
        });

        return response;
    } catch (err) {
        console.error(err);
        toast({
            title: `Nepavyko atlikti veiksmo (${endpoint})`,
            position: 'bottom',
            status: 'error',
            isClosable: true,
            duration: 4000
        });
    }
};
const openAll = () => sendGlobalDoorRequest('openall');
const openAllIPs = () => sendGlobalDoorRequest('openall-ips');
const closeAll = () => sendGlobalDoorRequest('closeall');
const closeAllIPs = () => sendGlobalDoorRequest('closeall-ips');


    const userLog = (cardNo, clickedID) => {
        axiosJWT.post(`/user_access_card_log`, {cardNo: JSON.stringify(cardNo)}).then((response) => {
            setPickedUserLog(response.data);
        });
    }

    // const allLogs = () => {
    //     setLoading(true);
    //     axiosJWT.get(`/get_all_logs`).then((response) => {
    //         setAllLog(response.data);
    //         setLoading(false);
    //     });
    // }
    const allLogs = async (fromDate, toDate) => {
  setLoading(true);
  try {
    const res = await axiosJWT.get('/get_all_logs', {
      params: {
        from: fromDate || undefined, // 'YYYY-MM-DD'
        to: toDate || undefined,
        // optional:
        // limit: 500,
        // cardNo: 12345,
      },
    });
    setAllLog(res.data || []);
  } finally {
    setLoading(false);
  }
};

    const getAllUsers = () => {
        setLoading(true);
        axiosJWT.get(`/get_all_users`).then((response) => {
            setAllUsers(response.data);
            setLoading(false);
        });
    }

    const getAllEmployees = () => {
        setLoading(true);
        axiosJWT.get(`/get_all_employees`).then((response) => {
            setAllEmployees(response.data);
            setLoading(false);
        });
    }

    const getAllCardGroups = () => {
        setLoading(true);
        axiosJWT.get(`/get_all_cardgroups`).then((response) => {
            setAllCardGroups(response.data);
            setLoading(false);
        });
    }

    const getAllDoors = () => {
        setLoading(true);
        axiosJWT.get(`/get_all_doors`).then((response) => {
            setAllDoors(response.data);
            setLoading(false);
        });
    }

    const getDoorInfo = async (doorID) => {
    const id = Number(doorID);
    
    if (!id || Number.isNaN(id)) {
        console.warn("getDoorInfo: blogas doorID →", doorID);
        return null;
    }

    try {
        const res = await axiosJWT.get(`/door_info/${id}`);
    
        const row = Array.isArray(res.data) ? res.data[0] : res.data;
        return row || null; // { DoorID, DoorName, DoorSerial, ... } arba null
    } catch (err) {
        console.error("Door info error", err);
        return null;
    }
    };

  const getAllSystemDoors = async () => {
    try {
      const res = await axiosJWT.get(`/doors_info`);
      setSystemDoors(res.data);   // <<--- SAUGOM FRONTENDE
      return res.data;
    } catch (err) {
      setSystemDoors([]);
      return [];
    }
  };

    function getDoorName(doorID) {
        const id = Number(doorID);
        const door = data.find(d => Number(d.doorID) === id);
        return door?.doorName || 'N/A';
    }

    function getDoorStatusBadge(status) {

        switch (status) {
            case 'OPEN':
                return { text: 'Atrakinta', color: 'green', icon: UnlockIcon, bgColor: '#38A169' }
            case 'OPEN_BUTTON':
                return { text: 'Atrakinta mygtuku', color: 'green', icon: UnlockIcon, bgColor: '#38A169' }
            case 'CLOSED':
            case 'CLOSED_ALL':
                return { text: 'Užrakinta', color: 'red', icon: LockIcon, bgColor: '#E53E3E' }
            case 'OPEN_LONG':
                return { text: 'Atrakinta ilgam', color: 'orange', icon: RepeatClockIcon, bgColor: '#DD6B20' }
            case 'EMERGENCY_OPEN':
            case 'EMERGENCY_OPEN_ALL':
                return { text: 'Avarinis atrakinimas', color: 'orange', icon: WarningIcon, bgColor: '#DD6B20' }
            case 'NO_ACCESS':
                return { text: 'Nėra prieigos', color: 'gray', icon: NotAllowedIcon, bgColor: '#718096' }
            case 'ENTERED_WHEN_OPEN':
                return { text: 'Buvo atrakintos', color: 'orange', icon: RepeatClockIcon, bgColor: '#DD6B20' }
            case 'NOT_FOUND':
                    return { text: 'Nėra sistemoje', color: 'gray', icon: NotAllowedIcon, bgColor: '#718096' }
            case 'DRUNK':
                    return { text: 'Girtas', color: 'red', icon: WarningTwoIcon, bgColor: 'red' }
            case 'OFFLINE':
                    return { text: 'Neprisijungus', color: 'gray', icon: NotAllowedIcon, bgColor: '#718096' };
            case 'UNKNOWN':
                    return { text: 'Būsena nežinoma', color: 'orange', icon: WarningIcon, bgColor: '#DD6B20' };
            case 'LOADING':
                    return { text: 'Kraunama...', color: 'blue', icon: RepeatClockIcon, bgColor: '#3182CE' };
        
            default:
                return { text: 'N/A', color: 'gray', icon: WarningIcon, bgColor: '#718096' }

        }

    }

   // sukuria axios klientą konkrečiam door IP
const createAxiosForDoorIp = (doorIp) => {
    const axiosJWT_ip = axios.create({
        baseURL: `http://${doorIp}:3000`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorization': user ? 'Bearer ' + user.accessToken : ''
        }
    });

    axiosJWT_ip.interceptors.request.use(async (config) => {
        const decodedToken = jwt_decode(user.accessToken);
        const hourInMilliseconds = 60 * 60 * 1000;
        const oneHourAfter = (decodedToken.iat * 1000) + hourInMilliseconds;

        if (Date.now() > oneHourAfter) {  // refresh token every hour
            console.log('new token');
            const data = await refreshToken();
            config.headers['authorization'] = "Bearer " + data.accessToken;
        }
        return config;
    }, (error) => {
        console.log('error');
        return Promise.reject(error);
    });

    return axiosJWT_ip;
};


//   // išorinės dėžės (kito Raspberry) axios instance
//   const axiosJWT_ip = axios.create({
//     baseURL: `http://${doorIp}:3000`,
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json',
//       'authorization': user ? 'Bearer ' + user.accessToken : ''
//     }
//   });

//   // tokeno refresh interceptor – BŪTINAI ant axiosJWT_ip, ne ant axiosJWT
//   axiosJWT_ip.interceptors.request.use(async (config) => {
//     const decodedToken = jwt_decode(user.accessToken);
//     const hourInMilliseconds = 60 * 60 * 1000;
//     const oneHourAfter = (decodedToken.iat * 1000) + hourInMilliseconds;

//     if (Date.now() > oneHourAfter) {  // refresh token every hour
//       console.log('new token');
//       const data = await refreshToken();
//       config.headers['authorization'] = "Bearer " + data.accessToken;
//     }
//     return config;
//   }, (error) => {
//     console.log('error');
//     return Promise.reject(error);
//   });

//   // baseURL jau turi http://doorIp:3000, tai čia rašom TIK path
//   axiosJWT_ip.post(`/open/${doorID}`, api_key)
//     .then((response) => {
//       toast({
//         title: response.data.message,
//         position: 'bottom',
//         status: response.data.status,
//         isClosable: true,
//         duration: 4000
//       });
//     })
//     .catch((err) => {
//       console.error(err);
//       toast({
//         title: 'Nepavyko atrakinti durų per IP ' + doorIp,
//         position: 'bottom',
//         status: 'error',
//         isClosable: true,
//         duration: 4000
//       });
//     });
// };

// pagal DoorID nusprendžiam, į kokį IP kreiptis
const getDoorIp = async (doorID) => {
    const info = await getDoorInfo(doorID); // { DoorSerial, ... } arba null
    if (!info) {
        // jei nepavyko gauti info – naudojam SERVER_IP
        return SERVER_IP;
    }
    const serial = info.DoorSerial ? String(info.DoorSerial).trim() : "";
    // jei nieko nenurodyta arba sutampa su SERVER_IP → naudojam pagrindinį serverį
    if (!serial || serial === SERVER_IP) {
        return SERVER_IP;
    }
    // kitaip laikom, kad tai kito Raspberry IP
    return serial;
};

 // 👇 bendras logas iš VISŲ IP
const loadLogAllIps = async (limit = 30) => {
  if (!user || !user.accessToken) return;

  try {
    const resp = await axiosJWT.get('/access_log_all', { params: { limit } });
    const next = resp.data || [];

    // jei niekas nepasikeitė – neperrašom state (mažiau renderių)
    if (
      logAllIps.length === next.length &&
      logAllIps[0]?.id === next[0]?.id
    ) {
      return;
    }

    setLogAllIps(next);
  } catch (err) {
    console.error('loadLogAllIps error:', err);
  }
};


const userLogIps = async (cardNo) => {
  if (!user || !user.accessToken) {
    console.warn('userLogIps: user not logged in, skipping');
    return;
  }

  setLoading(true);
  try {
    const resp = await axiosJWT.get('/access_log_all', {
      params: { limit: 30, cardNo },
    });
    setPickedUserLog(resp.data || []);
  } catch (err) {
    console.error('userLogIps error:', err);
    setPickedUserLog([]);
  } finally {
    setLoading(false);
  }
};

    return (
        <DoorContext.Provider value={{
            openDoor, openLongDoor, closeDoor, data, loadDataFromEmaitinimas, isSeveralRaspberryIps,
            openAll, openAllIPs, closeAll, closeAllIPs, loading, log, getDoorStatusBadge, getDoorName, client, axiosJWT, 
            setUser, user, userLog, pickedUserLog, logOutUser, allLogs, allLog, setAllLog, getAllUsers, allUsers,
            getAllEmployees, allEmployees, setAllEmployees,
            getAllCardGroups, allCardGroups,
            getAllDoors, allDoors,
            getAllSystemDoors, systemDoors, getDoorInfo, doorInfos, setDoorInfos,
            loadLogAllIps, userLogIps, logAllIps, setLogAllIps
        }}>
            {children}
        </DoorContext.Provider>
    )
}

export const useDoorData = () => useContext(DoorContext)

export default DoorContextProvider
